import api from '@/utils/api';
import {
    FETCH_FILTERS,
} from './types';
import { NotificationManager } from 'react-notifications';

export const fetchFilters = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/filters', { include: filter }).then(res => {
            dispatch({
                type: FETCH_FILTERS,
                payload: res.data
            });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        })
    })
}